export default {
  app:{
    name:'Inexplicable management system'
  },
  navbar: {
    logOut: 'Log Out',
    Home: 'Home Page',
    switchLanguage: 'switch Language'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    accountNotLess2:'account cannot be less than 2 characters',
    passwordNotLess6:'password cannot be less than 6 characters',
  },
  global: {
    prompt:'Prompt'
  }
}
